import request from '../../untils/request';

export function selectList(data) {
  return request({
    url: '/payOrder/selectList',
    method: 'get',
    params: data,
  });
}

// 售电订单打印数据
export function getPrintData(data) {
  return request({
    url: '/payOrder/getPrintData',
    method: 'get',
    params: { orderNo: data },
  });
}
// 批量打印
export function getBatchPrintData(data) {
  return request({
    url: '/payOrder/getBatchPrintData',
    method: 'post',
    data: data ,
  });
}
